import { Badge, Button } from "@light-technology/components";
import { Link01 } from "@untitledui/icons";
import { type AppResponse, type LinkedProgram } from "../../state/api.types";
import { programDetailsLink } from "../../utilities/links";
import { ProgramTypeIcon } from "../ProgramTypeIcon";

type LinkedProgramsProps = {
  app: AppResponse;
  programs: LinkedProgram[];
};

const LinkedProgramCard = ({
  app,
  program,
}: {
  app: AppResponse;
  program: LinkedProgram;
}) => {
  return (
    <div className="flex flex-col gap-xl overflow-clip rounded-2xl border border-secondary p-3xl">
      <div className="self-start">
        <Badge size="sm" color="gray" type="pill-color">
          <span className="flex items-center gap-1">
            <Link01 className="size-3" />
            Default program
          </span>
        </Badge>
      </div>
      <div className="flex flex-col">
        <div className="flex items-center gap-1">
          <ProgramTypeIcon programType={program.program_type} />
          <span className="truncate font-semibold text-secondary">
            {program.name}
          </span>
        </div>
        <div className="min-h-[2lh] text-sm"></div>
      </div>
      <Button
        size="sm"
        color="secondary"
        href={programDetailsLink(app.slug, program.uuid)}
        className="self-start"
      >
        View
      </Button>
    </div>
  );
};

export const LinkedPrograms = ({ app, programs }: LinkedProgramsProps) => {
  if (programs.length === 0) return null;

  return (
    <div className="grid grid-cols-2 gap-5xl">
      {programs.map((program) => (
        <LinkedProgramCard key={program.uuid} app={app} program={program} />
      ))}
    </div>
  );
};
